
import { CityParams, POIParams, TripPOIParams } from './importExportTypes';
import importExportApi   from './importExportApi';


// Strategy function types
type ImportStrategy<T> = (params: T) => Promise<Response>;

// Strategy implementations
export const importStrategies = {

  City: async (params: CityParams) => {
      const formData = new FormData();
      formData.append('RegionID', params.RegionID);
      formData.append('RegionName', params.RegionName);
      formData.append('CityFile', params.CityFile);
      formData.append('ImportStatus', params.ImportStatus);

      return importExportApi.importCity(formData);
  },

  POI: async (params: POIParams) => {
    const formData = new FormData();
      formData.append('CityID', params.CityID);
      formData.append('CityName', params.CityName);
      formData.append('RegionPOIFile', params.RegionPOIFile);
      formData.append('ImportStatus', params.ImportStatus);

    return importExportApi.importPOI(formData);
  },

  TripPOI: async (params: TripPOIParams) => {
    const formData = new FormData();
    formData.append('TripManagementID', params.TripManagementID);
    formData.append('TripName', params.TripName);
    formData.append('TripPOIFile', params.TripPOIFile);
    formData.append('ImportStatus', params.ImportStatus);

    return importExportApi.importTripPOI(formData);
  },
} as const;

// Types for keys and strategy lookup
export type ImportOption = keyof typeof importStrategies;
